import { useContext } from 'react';
import { AuthContext } from '../context/AuthContextInterface';

export const useAuth = () => {
  return useContext(AuthContext);
};
